import { PurchaseStateAndDelivery } from "@smartrr/shared/entities/PurchaseState";
import { IPurchaseStateLineItem } from "@smartrr/shared/entities/PurchaseState/CustomerPurchaseLineItem";

export function isLineItemInDelivery(
  lineItem: IPurchaseStateLineItem,
  delivery: PurchaseStateAndDelivery
): boolean {
  const { stLineItems } = delivery.purchaseState;
  const isInDelivery = stLineItems.some(li => li.id === lineItem.id);
  if (lineItem.isAddOn) {
    const doesScheduleIndexMatch = lineItem.skdIdx === delivery.indexFromScheduleStart;
    return doesScheduleIndexMatch && isInDelivery;
  }
  return isInDelivery;
}
